import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from '../services/apiClient';

const base = '/api/admin/cabs';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    qs.set(key, String(value));
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listResource = (resource, params) => apiGet(`${base}/${resource}${buildQuery(params)}`);
export const createResource = (resource, payload) => apiPost(`${base}/${resource}`, payload);
export const updateResource = (resource, id, payload) => apiPut(`${base}/${resource}/${id}`, payload);
export const toggleResourceStatus = (resource, id, isActive) =>
  apiPatch(`${base}/${resource}/${id}/status`, { isActive });

export const getCabDashboard = () => apiGet(`${base}/dashboard`);
export const getCabLandingPageSettings = () => apiGet(`${base}/landing-page-settings`);
export const updateCabLandingPageSettings = (payload) => apiPut(`${base}/landing-page-settings`, payload);

export const listVehicleImages = (vehicleId) => apiGet(`${base}/vehicles/${vehicleId}/images`);
export const createVehicleImage = (vehicleId, payload) => apiPost(`${base}/vehicles/${vehicleId}/images`, payload);
export const deleteVehicleImage = (id) => apiDelete(`${base}/vehicle-images/${id}`);
export const setVehicleImageCover = (id, isCover) => apiPatch(`${base}/vehicle-images/${id}/cover`, { isCover });

export const listVehicleAmenities = (vehicleId) => apiGet(`${base}/vehicles/${vehicleId}/amenities`);
export const setVehicleAmenities = (vehicleId, amenityIds) =>
  apiPut(`${base}/vehicles/${vehicleId}/amenities`, { amenityIds });

export const listTransportPackageMedia = (packageId) => apiGet(`${base}/transport-packages/${packageId}/media`);
export const createTransportPackageMedia = (packageId, payload) =>
  apiPost(`${base}/transport-packages/${packageId}/media`, payload);
export const deleteTransportPackageMedia = (id) => apiDelete(`${base}/transport-package-media/${id}`);
export const setTransportPackageMediaCover = (id, isCover) =>
  apiPatch(`${base}/transport-package-media/${id}/cover`, { isCover });

export const uploadAdminImage = async (file) => {
  const form = new FormData();
  form.append('image', file);
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL || ''}/api/admin/upload`, {
    method: 'POST',
    credentials: 'include',
    body: form,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || 'Upload failed');
  return data;
};

export const listPopularRouteGroups = (params) => apiGet(`${base}/popular-route-groups${buildQuery(params)}`);
export const createPopularRouteGroup = (payload) => apiPost(`${base}/popular-route-groups`, payload);
export const updatePopularRouteGroup = (id, payload) => apiPut(`${base}/popular-route-groups/${id}`, payload);
export const togglePopularRouteGroup = (id, isActive) =>
  apiPatch(`${base}/popular-route-groups/${id}/status`, { isActive });

export const listPopularRouteItems = (params) => apiGet(`${base}/popular-route-items${buildQuery(params)}`);
export const createPopularRouteItem = (payload) => apiPost(`${base}/popular-route-items`, payload);
export const updatePopularRouteItem = (id, payload) => apiPut(`${base}/popular-route-items/${id}`, payload);
export const togglePopularRouteItem = (id, isActive) =>
  apiPatch(`${base}/popular-route-items/${id}/status`, { isActive });

export const listAdminEnquiries = (params) => apiGet(`${base}/enquiries${buildQuery(params)}`);
export const getAdminEnquiry = (id) => apiGet(`${base}/enquiries/${id}`);
export const updateAdminEnquiry = (id, payload) => apiPatch(`${base}/enquiries/${id}`, payload);


